<template>
  <div class="wrapper">
	   <LeftMenu :currentIndex="0"></LeftMenu>
		<div class="content">
			<img  src="../../static/p1-img1.png"/>
			<div class="notice-box" v-if="isShowNews" @click="showDetail">
				<img src="../../static/icon7.png" class="notice-icon"/>
				<img :src="parseImg(newsList[0].ico)" class="news-ico"/>
				<div class="news-title" v-html="parseTitle(newsList[0].title)" ref="myDiv"></div>
				<!-- <div class="news-title" ref="myDiv">
					{{newsList[0].title}}
				</div> -->
			</div>
		</div>
		<!-- <div class="icon-wrapper">
		  <span class="icon icon-1"></span>
		  <span class="icon icon-2"></span>
		</div> -->
		<img src="../../static/footer-w.png" class="fotImg"/>
		<NewsDetail :newsInfo="newsList[0]" v-if="showDetailPage"></NewsDetail>
  </div>
</template>

<script>
  import axios from 'axios';
	
  export default {
	name: 'Home',
	components: {
		LeftMenu: () => import('../components/LeftMenu.vue'),
		NewsDetail: () => import('../components/NewsDetail.vue'),
	},
    data() {
      return {
        src: require('../../static/p1-img1.png'),
		moreSrc:require('../../static/icon8.png'),
		isShowNews: false,
		baseUrl: 'http://kingstronbio.slinqueen.com',
		appid: "sqks",
		api_secret: "abcdefg",
		timestamp: Date.parse(new Date()) / 1000,
		jiami:'',
		newsList:[],
		showDetailPage: false,
		// newItem:{},
      }
    },
	methods:{
		async getCompany() {
			//可进行解耦   公司新闻 17    科普知识 18    临床病例19    全部 12
			var that = this;
			await axios (
				{
					url: '//kingstronbio.slinqueen.com/api.php/list/12/num/100',
					method: 'POST',
					params: {
						"appid": this.appid,
						"signature": md5(md5(this.jiami)),
						"timestamp": this.timestamp,
					}
				}
			)
			.then(res => {
				that.listResult = res.data.data;
				that.newsList = that.listResult.filter(item=>item.scode==="17"); //公司新闻
				
				that.parseNews(that.newsList[0])
				
			}, error => {
				console.log(error)
			})
		
		},
		parseImg(img) {
			return this.baseUrl + img;
		},
		parseNews(item){
			const startDate = new Date();
			const endDate = new Date(item.date);
					
			// 计算两个日期之间的天数差
			const diff = Math.abs((startDate.getTime() - endDate.getTime()) / (1000 * 60 * 60 * 24));
			this.isShowNews = diff<=3 ? true: false;
		},
		showDetail(){
			this.$store.commit("setIsListening", false);
			this.showDetailPage = true ;//内容详情
		},
		parseTitle(title){
			return title+ "<img src="+this.moreSrc+" class='moreBtn'/>"
		}
	},
	mounted() {
		this.jiami = this.appid + this.api_secret + this.timestamp;
		this.getCompany();
		 
	}
  }
</script>

<style lang="less" scoped>
	@import '../assets/css/index';
	img{
		display: block;
		width: 100%;
	}
	.content{
		position: relative;
		width: 100%;
		// img{
		// 	.scale(1680,968);
		// }
		.notice-box{
			.scale(650,90);
			.pos-a(677, 185, 4);
			display: flex;
			flex-direction: row;
			cursor: pointer;
			.notice-icon{
				.scale(27,30);
			}
			.news-ico{
				margin-left: 10/@r;
				width: 114/@r;
				height: auto;
			}
			.news-title{
				position: relative;
				margin-left: 10/@r;
				font-size: 18/@r;
				height: 70/@r;
				color: #fff;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 3;  // 显示几行
				-webkit-box-orient: vertical;
				overflow: hidden;
			}
			/deep/.moreBtn{
				width: 20/@r;
				height: 20/@r;
				margin-left: 10/@r;
				display: inline-block;
				position: absolute;
				margin-top: 3/@r;
			}
		}
	}
	.fotImg{
		position: absolute;
		left: 52/@r;
		bottom: 52/@r;
		width: 458/@r;
		height: 13/@r;
		z-index: 9;
	}
	.wrapper{
		position: relative;
		width: 1681/@r;
		height: 967/@r;
	}
	.icon-wrapper {
	  position: absolute;
	  top: 61.2%;
	  left: 31.3%;
	  z-index: 2;
	  // .pos-a(590,534,2);
	  .scale(140,64);
	}
	
	.icon {
	  .scale(64,64);
	  display: inline-block;
	  margin-right: 8/@r;
	  background: url('../../static/p1-img2.png');
	  background-size: 282/@r 64/@r;
	  background-repeat: no-repeat;
	  // background-color: transparent; /* 隐藏原图片 */
	  overflow: hidden;
	  &:last-child {
		 margin-right: 0;
	  }
	}
	.icon.icon-1 {
	  background-position: 0 0;
	  &:hover{
		  background-position: -146/@r 0;
	  }
	}
	
	.icon.icon-2 {
	  background-position: -71/@r 0;
	  &:hover{
	  	background-position: -218/@r 0;
	  }
	}
	
</style>
